// extracted by mini-css-extract-plugin
export var connectionButton = "_a5-1";
export var rightPanel = "_a5-3";
export var stepDescription = "_a5-2";
export var stepIcon = "_a5-0";